import React, { useEffect } from 'react';
import { CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Stack } from '@mui/material';

function Home() {
	const navigate = useHistory();

	useEffect(() => {
		navigate.push('/dashboard');
	}, []);

	return (
		<Stack alignItems="center">
			<CircularProgress />{' '}
		</Stack>
	);
}

Home.propTypes = {};

export default Home;
